import hobbesPic from "@/public/images/artists/hobbes.jpg";
import { Artist } from "@/types/types";

export const hobbes = {
  id: "285",
  name: "Hobbes",
  image: hobbesPic,
  description: `Hobbes has a bright, forward-placed chest voice with a strong, expressive delivery, suited for classical and theatrical pieces.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fhobbes-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Classical", "Theatrical"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 49,
        high: 65,
      },
      sweetSpot: 59,
    },
  },
} satisfies Artist;
